export default __webpack_public_path__ + "alberta-nursingservice.c2887fbe70d9e65a0fda.svg";